import { Routes } from '@angular/router';
import { authGuard } from '../features/auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('../features/auth/presentation/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'onboarding',
    loadComponent: () =>
      import('../features/auth/presentation/onboarding/onboarding.component').then(m => m.OnboardingComponent),
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () =>
      import('../features/board/presentation/board-resolver/board-resolver.component').then(m => m.BoardResolverComponent),
  },
  {
    path: ':boardId',
    loadComponent: () =>
      import('../features/board/presentation/layout/board-layout.component').then(m => m.BoardLayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'board',
        pathMatch: 'full',
      },
      {
        path: 'board',
        loadComponent: () =>
          import('../features/board/presentation/grid/grid.component').then(m => m.GridComponent),
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('../features/dashboard/presentation/dashboard-page/dashboard-page.component').then(m => m.DashboardPageComponent),
      },
      {
        path: 'taxes',
        loadComponent: () =>
          import('../features/taxes/presentation/taxes-page/taxes-page.component').then(m => m.TaxesPageComponent),
      },
      {
        path: 'invoices',
        loadComponent: () =>
          import('../features/invoices/presentation/invoices-page/invoices-page.component').then(m => m.InvoicesPageComponent),
      },
    ],
  },
];
